import React, { useState } from "react";
import { Modal, Button, Toast, ToastContainer } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import PatientNote from "../PatientPage/PatientNote";
import DoctorPrescription from "../PatientPage/DoctorPrescription"; // Importing the Doctor Prescription Component
import { MdCopyAll, MdOutlineNoteAlt, MdMedicalServices } from "react-icons/md";

const RoomLabel = ({ roomId }) => {
  const [showPatientNote, setShowPatientNote] = useState(false);
  const [showDoctorPrescription, setShowDoctorPrescription] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const baseUrl = window.location.origin;
  const joinRoomUrl = `${baseUrl}/join-room?id=${roomId}`;

  if (roomId) {
    // localStorage.setItem("roomId", roomId);
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(joinRoomUrl)
      .then(() => setShowToast(true))
      .catch(err => console.error("Failed to copy:", err));
  };

  return (
    <div className="room_label d-flex align-items-center">
      <p className="room_label_paragraph mb-0 d-flex align-items-center">
        {/* <a href={joinRoomUrl} target="_blank" rel="noopener noreferrer" className="room_label_link"> {joinRoomUrl}
        </a> */}

        {/* <MdCopyAll
          className="copy-icon mx-3"
          onClick={handleCopy}
          style={{ cursor: "pointer", }}
        /> */}

        {/* Open Patient Note Popup Icon */}
        <MdOutlineNoteAlt
          className="open-popup-icon mx-3"
          onClick={() => setShowPatientNote(true)}
          style={{ cursor: "pointer", }}
        />

        {/* Open Doctor Prescription Popup Icon */}
        <MdMedicalServices
          className="open-popup-icon mx-3"
          onClick={() => setShowDoctorPrescription(true)}
          style={{ cursor: "pointer", }}
        />
      </p>


      {/* Toast Notification */}
      <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={2000} // Auto-hide after 2 seconds
        autohide
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          backgroundColor: "#28a745",
          color: "white",
          padding: "10px",
          borderRadius: "5px"
        }}
      >
        <Toast.Body>🔗 Link copied to clipboard!</Toast.Body>
      </Toast>


      {/* Modal for Patient Note */}
      <Modal show={showPatientNote} onHide={() => setShowPatientNote(false)} size="lg" className="modal-top-spacing">
        <Modal.Header closeButton>
          <Modal.Title>Patient Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PatientNote />
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPatientNote(false)}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      {/* Modal for Doctor Prescription */}
      <Modal show={showDoctorPrescription} onHide={() => setShowDoctorPrescription(false)} size="lg" className="modal-top-spacing">
        <Modal.Header closeButton>
          <Modal.Title>Doctor Prescription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DoctorPrescription />
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDoctorPrescription(false)}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default RoomLabel;
